import { render } from "./newFiveMuseum.vue?vue&type=template&id=58a0ee78&scoped=true"
import script from "./newFiveMuseum.vue?vue&type=script&lang=js"
export * from "./newFiveMuseum.vue?vue&type=script&lang=js"

import "./newFiveMuseum.vue?vue&type=style&index=0&id=58a0ee78&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a0ee78"]])

export default __exports__